import React, { useEffect, useState, useRef } from 'react'

const Counter = () => {
  const [statesCount, setStatesCount] = useState(0)
  const [projectsCount, setProjectsCount] = useState(0)
  const [clientsCount, setClientsCount] = useState(0)
  const counterRef = useRef(null)

  useEffect(() => {
    const counters = [
      { target: 10, setCount: setStatesCount },
      { target: 80, setCount: setProjectsCount },
      { target: 150, setCount: setClientsCount },
    ]

    const handleCount = (entries) => {
      if (entries[0].isIntersecting) {
        counters.forEach(({ target, setCount }) => {
          let start = 0
          const increment = target / 100

          const updateCounter = setInterval(() => {
            start += increment
            if (start >= target) {
              setCount(target)
              clearInterval(updateCounter)
            } else {
              setCount(Math.ceil(start))
            }
          }, 30)
        })

        observer.unobserve(counterRef.current)
      }
    }

    const observer = new IntersectionObserver(handleCount)
    if (counterRef.current) {
      observer.observe(counterRef.current)
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current)
      }
    }
  }, [])

  return (
    <section ref={counterRef} id="contador" className="flex-center flex-column">
      <div className="padding-100 flex-center">
        <div
          id="container-counter"
          className="flex-center flex__gap-100 title-main"
        >
          <div className="result-content flex-center flex-column flex__gap-10">
            <span className="count">+ {statesCount}</span>
            <span className="title-count">Estados</span>
          </div>
          <div className="result-content flex-center flex-column flex__gap-10">
            <span className="count">+ {projectsCount}</span>
            <span className="title-count">Projetos</span>
          </div>
          <div className="result-content flex-center flex-column flex__gap-10">
            <span className="count">+ {clientsCount}</span>
            <span className="title-count">Clientes</span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Counter
